<template>
  <div class="topic-page">
    <Head />
    <Box1 />
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />
    <Box8 />
    <Box9 />
    <Box10 />
    <Box13 />
    <Foot />
    <Zx />
  </div>
</template>

<script>
import Head from "./topicPage/head.vue";
import Box1 from "./topicPage/box1.vue";
import Box2 from "./topicPage/box2.vue";
import Box3 from "./topicPage/box3.vue";
import Box4 from "./topicPage/box4.vue";
import Box5 from "./topicPage/box5.vue";
import Box6 from "./topicPage/box6.vue";
import Box7 from "./topicPage/box7.vue";
import Box8 from "./topicPage/box8.vue";
import Box9 from "./topicPage/box9.vue";
import Box10 from "./topicPage/box10.vue";
import Box13 from "./topicPage/box13.vue";
import Foot from "../../components/common/foot.vue";
import Zx from "../../components/common/zx.vue";
export default {
  components: {
    Head,
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    Box10,
    Box13,
    Foot,
    Zx
  },
  data() {
    return {
    };
  },
  methods: {
    itcastClick() {
      qimosdk.hideChatBox();
      setTimeout(function(){
        qimoChatClick();
      },200);
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  overflow: auto;
  min-width: 1400px;
}
</style>
